import { storyblokEditable } from "@storyblok/react";
 
const BrandsOverview = ({ blok }) => (
    <div className="brandsoverview-wrap wrap flex justify-center" {...storyblokEditable(blok)}>
        <img src={blok.image.filename} alt={blok.image.alt} />
    </div>
)
export default BrandsOverview; 